import React, { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Alert, Loader, Tabs } from '@itds/elements/index.js';

//import Config from '@/config';

//import General from './General';
import LimitCarriers from './LimitCarriers';
import LimitProductTypes from './LimitProductTypes';
import H1 from '@brokerage/components/H1';
import LimitStates from '@brokerage/components/LimitStates';

import { Api } from '@brokerage/utils/Api';
import ApiClient from './ApiClient';

export const Show = () => {
  const params = useParams();
  const hash = window.location.hash;

  const [vive_quoter, setViveQuoter] = useState({});
  const [error_message, setErrorMessage] = useState();
  const [success_message, setSuccessMessage] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadViveQuoter();
  }, []);

  useEffect(() => {
    return () => {
      setViveQuoter({});
    };
  }, []);

  const loadViveQuoter = () => {
    Api.loadApiClient(params.id)
      .then(({ data }) => {
        setViveQuoter(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleStatesChange = ({ default_state, states }) => {
    handleSave({ default_state, states });
  };

  const handleSave = input_fields => {
    window.scrollTo(0, 0);

    Api.updateViveQuoter(params.id, input_fields)
      .then(() => {
        loadViveQuoter(params.id);
        setErrorMessage(null);
        setSuccessMessage('Vive Update Successfully');

        setTimeout(() => {
          setSuccessMessage(null);
        }, 2000);
      })
      .catch(() => {
        setSuccessMessage(null);
        setErrorMessage('Unable to update Vive');

        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };

  const child_props = {
    vive_quoter,
    handleSave,
    loadViveQuoter,
    setViveQuoter,
    setErrorMessage,
    setSuccessMessage
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <H1>{vive_quoter.name}</H1>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Tabs
          tabs={[
            {
              label: 'General',
              to: ' ',
              isActive:
                hash.slice(-1) === `${vive_quoter.id}`.slice(-1) || hash.slice(-1) === '/'.slice(-1)
            },
            {
              label: 'Limit Carriers',
              to: 'limit_carriers',
              isActive: hash.includes('limit_carriers')
            },
            {
              label: 'Limit Product Types',
              to: 'limit_product_types',
              isActive: hash.includes('limit_product_types')
            },
            {
              label: 'Limit States',
              to: 'limit_states',
              isActive: hash.includes('limit_states')
            }
          ]}
          vertical={true}
        />

        <div style={{ flex: 1, marginLeft: 40 }}>
          <Routes>
            <Route element={<ApiClient {...child_props} />} index={true} />
            <Route element={<LimitCarriers {...child_props} />} path='limit_carriers' />
            <Route element={<LimitProductTypes {...child_props} />} path='limit_product_types' />
            <Route
              element={
                <LimitStates
                  defaultState={vive_quoter.default_state}
                  handleSave={handleStatesChange}
                  selectedStates={vive_quoter.states}
                />
              }
              path='limit_states'
            />
          </Routes>
        </div>
      </div>
    </>
  );
};

Show.propTypes = {
  name: PropTypes.string
};
